import MUIAvatar from '@mui/material/Avatar'

export const Avatar = MUIAvatar
